export const CIVILMATERIALCATEGORY_LOADING = "CIVILMATERIALCATEGORY_LOADING";
export const CIVILMATERIALCATEGORY_RESET = "CIVILMATERIALCATEGORY_RESET";
export const GET_CIVILMATERIALCATEGORY = "GET_CIVILMATERIALCATEGORY";
export const GET_CIVILMATERIALCATEGORY_SUCCESS = "GET_CIVILMATERIALCATEGORY_SUCCESS";
export const GET_CIVILMATERIALCATEGORY_FAIL = "GET_CIVILMATERIALCATEGORY_FAIL";
export const DELETE_CIVILMATERIALCATEGORY = "DELETE_CIVILMATERIALCATEGORY"
export const DELETE_CIVILMATERIALCATEGORY_SUCCESS = "DELETE_CIVILMATERIALCATEGORY_SUCCESS"
export const DELETE_CIVILMATERIALCATEGORY_FAIL = "DELETE_CIVILMATERIALCATEGORY_FAIL"
export const UPDATE_CIVILMATERIALCATEGORY = "UPDATE_CIVILMATERIALCATEGORY"
export const UPDATE_CIVILMATERIALCATEGORY_SUCCESS = "UPDATE_CIVILMATERIALCATEGORY_SUCCESS"
export const UPDATE_CIVILMATERIALCATEGORY_FAIL = "UPDATE_CIVILMATERIALCATEGORY_FAIL"
export const ADD_NEW_CIVILMATERIALCATEGORY = "ADD_NEW_CIVILMATERIALCATEGORY"
export const ADD_CIVILMATERIALCATEGORY_SUCCESS = "ADD_CIVILMATERIALCATEGORY_SUCCESS"
export const ADD_CIVILMATERIALCATEGORY_FAIL = "ADD_CIVILMATERIALCATEGORY_FAIL"